"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { TOAST_ICONS } from "./toastIcons";
import { type ToastKind, toastStore } from "./toastStore";
const DISPLAY_DURATION_MS = 5000;
const EXTENDED_DURATION_MS = 1000;
const FADE_OUT_DURATION_MS = 1000;
const BACKGROUND_CLASS_NAMES: Record<ToastKind, string> = {
  success: "bg-[#51a351]",
  error: "bg-[#bd362f]"
};
type ToastItemProps = {
  toastId: number;
  kind: ToastKind;
  message: string;
};
export const ToastItem = t0 => {
  const $ = _c(20);
  const {
    toastId,
    kind,
    message
  } = t0;
  const [isLeaving, setIsLeaving] = useState(false);
  const hideTimer = useRef(undefined);
  let t1;
  if ($[0] !== toastId) {
    t1 = () => {
      setIsLeaving(true);
      hideTimer.current = setTimeout(() => toastStore.remove(toastId), FADE_OUT_DURATION_MS);
    };
    $[0] = toastId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hide = t1;
  let t2;
  if ($[2] !== hide) {
    t2 = delay => {
      clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(hide, delay);
    };
    $[2] = hide;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const scheduleHide = t2;
  let t3;
  let t4;
  if ($[4] !== scheduleHide) {
    t3 = () => {
      scheduleHide(DISPLAY_DURATION_MS);
      return () => clearTimeout(hideTimer.current);
    };
    t4 = [scheduleHide];
    $[4] = scheduleHide;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      clearTimeout(hideTimer.current);
      setIsLeaving(false);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleMouseEnter = t5;
  const t6 = `toast toast-${kind} w-[300px] cursor-pointer rounded-[3px] bg-[15px_center] bg-no-repeat py-[15px] pl-[50px] pr-[15px] text-sm leading-5 text-white transition-opacity hover:opacity-100 starting:opacity-0 ${BACKGROUND_CLASS_NAMES[kind]} ${isLeaving ? "opacity-0 duration-1000" : "opacity-80 duration-300"}`;
  const t7 = `url("${TOAST_ICONS[kind]}")`;
  let t8;
  if ($[8] !== t7) {
    t8 = {
      backgroundImage: t7
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== scheduleHide) {
    t9 = () => scheduleHide(EXTENDED_DURATION_MS);
    $[10] = scheduleHide;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== message) {
    t10 = <div className="break-words">{message}</div>;
    $[12] = message;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== hide || $[15] !== t10 || $[16] !== t6 || $[17] !== t8 || $[18] !== t9) {
    t11 = <div role="alert" className={t6} style={t8} onMouseEnter={handleMouseEnter} onMouseLeave={t9} onClick={hide}>{t10}</div>;
    $[14] = hide;
    $[15] = t10;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};